import React from 'react';
import styles from '../../styles/match-event-placeholders.module.scss'
import classNames from "classnames";
import {MatchEventModulePlaceholderEvent} from "./match-event.module.placeholder.event";

export const MatchEventModulePlaceholderRow = () => {
  return (
    <>
      <div className={classNames(styles.row_divider)}/>
      <div className={classNames(styles.row)}>
        <MatchEventModulePlaceholderEvent/>
        <div className={classNames(styles.time)}/>
        <MatchEventModulePlaceholderEvent invert/>
      </div>
    </>
  )
};
